@if (districts && kvDistricts) {
  <p-dropdown
    [options]="districts"
    [(ngModel)]="selection"
    [ngModelOptions]="{ standalone: isStandalone }"
    [placeholder]="placeholder"
    optionLabel="name"
    optionValue="key"
    (ngModelChange)="onChange($event)">
    <ng-template let-district pTemplate="selectedItem">
      <div class="flex align-items-center gap-2" *ngIf="selection">
        <i class="fas fa-map-location-dot"></i>
        <div>{{ district.name }}</div>
      </div>
    </ng-template>
    <ng-template let-district pTemplate="item">
      <div class="flex align-items-center gap-2">
        <i class="fas fa-map-location-dot"></i>
        <span>{{ district.name }}</span>
      </div>
    </ng-template>
  </p-dropdown>
}
